export const ids = [
	'notStarted',
	'unAllocated',

	'processing',

	'complete',

	//
	'ready',
	'inProgress',

	// Alternative complete statuses,
	'approved',
	'notRequired',

	// Exception statuses,
	'cancelled',
	'failed',
	'aborted',
	'onHold',
	'pendingFeedback',

	// client facing ones
	'pending',
	'assigned',
	'review',
	'reworkInProgress',

	// pricing / estimate management
	'sentToCustomer',
	'followUpScheduled',

	// production specific statuses
	'paperworkCompleted',
	'lumberPulling',
	'cutting',
	'fabrication',
] as const;
